const navs = {
	mainNav: {
		items: [
			{
				linkTo: '/cameras',
				name: 'cameras',
				code: 'CAMERA',
				exact: true,
				strict: false,
				subItems: [
					{
						linkTo: '/cameras/ip',
						name: 'IP',
						code: 'IP',
						exact: true,
						strict: false,
						subItems: []
					},
					{
						linkTo: '/cameras/ahd',
						name: 'AHD',
						code: 'AHD',
						exact: true,
						strict: false,
						subItems: []
					},
					{
						linkTo: '/cameras/wifi',
						name: 'WIFI',
						code: 'WIFI',
						exact: true,
						strict: false,
						subItems: []
					},
					{
						linkTo: '/cameras/4g',
						name: '4G',
						code: 'C4G',
						exact: true,
						strict: false,
						subItems: []
					},
				]
			},
			{
				linkTo: '/recorders',
				name: 'recorders',
				code: 'RECORDER',
				exact: true,
				strict: false,
				subItems: [
					{
						linkTo: '/recorders/nvr',
						name: 'NVR',
						code: 'NVR',
						exact: true,
						strict: false,
						subItems: []
					},
					{
						linkTo: '/recorders/xvr',
						name: 'XVR',
						code: 'XVR',
						exact: true,
						strict: false,
						subItems: []
					},
				]
			},
			{
				linkTo: '/accessories',
				name: 'accessories',
				code: 'ACCESSORY',
				exact: false,
				strict: false,
				subItems: []
			},
			{
				linkTo: '/smart-home',
				name: 'smart-home',
				code: 'SMARTHOME',
				exact: false,
				strict: false,
				subItems: []
			},
			{
				linkTo: '/archive',
				name: 'archive',
				code: 'ARCHIVE',
				exact: false,
				strict: false,
				subItems: []
			},
			{
				linkTo: '/about-us',
				name: 'about-us',
				code: 'ABOUT_US',
				exact: false,
				strict: false,
				subItems: []
			},
			{
				linkTo: '/support',
				name: 'support',
				code: 'SUPPORT',
				exact: false,
				strict: false,
				subItems: []
			},
			{
				linkTo: '/contact-us',
				name: 'contact-us',
				code: 'CONTACT_US',
				exact: false,
				strict: false,
				subItems: []
			},
		]
	}
};

export default navs;


// WEBPACK FOOTER //
// ./src/config/navs.js